let api:any;
let blobapi:any;
if (process.env.REACT_APP_ENV === "prod") {
  api = process.env.REACT_APP_SERVER_API_PROD;
  blobapi = process.env.REACT_APP_SERVER_BLOB_API_PROD;
} else {
  api = process.env.REACT_APP_SERVER_API_DEV;
  blobapi = process.env.REACT_APP_SERVER_BLOB_API_DEV;
}
export const API_URL = api  ;
export const BLOB_API = blobapi ;
export const API_VERSION = 'v1';
export const APP_MAINPAGE_URL = process.env.REACT_APP_MAINPAGE_URL || "https://www.srbf.in/";